<template>
    <div class="sidebar-ranking" v-if="showComponent() && providers.length">
        <h2 class="sidebar-ranking__title">
            {{ $t('Best VPN Offers') }}
        </h2>

        <SidebarRankingCard
            v-for="(partner, index) in topThreePartners"
            :key="index"
            :partner="partner"
            :index="index"
            v-bind="{
                ...styleProps,
            }"
        />
    </div>
</template>

<script>
import SidebarRankingCard from './SidebarRankingCard.vue';
import { ghostWriterRankingMixin } from '@/ghost-mixins';

export default {
    name: 'SidebarRanking',
    components: {
        SidebarRankingCard,
    },
    mixins: [ghostWriterRankingMixin],
    props: {
        providers: {
            type: Array,
            default: () => [],
        },
        providerCount: {
            type: Number,
            default: 3,
        },
    },
    data() {
        return {
            styleProps: this.getStyleProps(),
        };
    },
    computed: {
        topThreePartners() {
            return this.providers.slice(0, this.providerCount);
        },
    },
    methods: {
        getStyleProps() {
            const settings =
                this.$globalConstants.components['GhostWriterSettings'] || {};
            return {
                ctaButtonColor: settings['ctaButtonBackgroundColor'],
                ctaButtonTextColor: settings['ctaButtonTextColor'],
                flagTextColor: settings['ctaButtonTextColor'],
                flagBackgroundColor: settings['ctaButtonBackgroundColor'],
            };
        },
        showComponent() {
            if (this.$attrs?.content) {
                return this.isMobile();
            }
            return !this.isMobile();
        },
    },
};
</script>

<style lang="scss" scoped>
.sidebar-ranking {
    display: flex;
    flex-direction: column;
    gap: 20px;

    .sidebar-ranking__title {
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        margin-bottom: 16px;
    }
}
</style>
